import { render, staticRenderFns } from "./PopularArtists.vue?vue&type=template&id=a24e3c82&scoped=true"
import script from "./PopularArtists.vue?vue&type=script&lang=js"
export * from "./PopularArtists.vue?vue&type=script&lang=js"
import style0 from "./PopularArtists.vue?vue&type=style&index=0&id=a24e3c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24e3c82",
  null
  
)

export default component.exports